<template>
    <div class="DetailSpecificationButtons">
        <div
            v-for="(sp, spi) in specifications"
            :key="sp.name"
            class="DetailSpecificationButtons-item">
            <div class="DetailSpecificationButtons-item_label">{{ sp.name }}：</div>
            <div class="DetailSpecificationButtons-item_content">
                <el-radio-group v-model="chooseForm[spi]" @change="(value) => emitChange(value, sp.values)" size="small">
                    <el-tooltip v-for="(spv,index) in sp.values"
                                   :key="spv.value+index"
                                   :content="'商品已停用'"
                                   :disabled="!isDisabled(spv.value, spi)"
                                   placement="top">
                        <el-radio
                            :label="spv.value"
                            :disabled="isDisabled(spv.value, spi)"
                            border>
                            <img v-if="!spi && spv.imageUrl" class="spvImage" :src="spv.imageUrl === '/resources/css/build/images/no_pic.png' ? no_pic : spv.imageUrl" /> {{ spv.value }}
                        </el-radio>
                    </el-tooltip>
                </el-radio-group>
            </div>
        </div>
    </div>
</template>

<script>
import no_pic from '@/assets/images/no_pic.png'
export default {
    name: "DetailSpecificationButtons",
    props: {
        specifications: {
            type: Array,
            default() {
                return []
            }
        },
        skuList: {
            type: Array,
            default() {
                return []
            }
        },
    },
    data() {
        return {
            chooseForm: [],
            no_pic,
        }
    },
    computed: {
        skuMap() {
            let map = {};
            this.skuList.forEach(sku => {
                let _sku_id = sku.skuSpecifications.map(({value}) => value).join('-')
                map[_sku_id] = sku
            })
            return map
        },
        selectedSku() {
            return this.skuMap[this.chooseForm.join('-')] || null
        }
    },
    watch: {
        specifications: {
            immediate: true,
            handler(v) {
                // 初始化时，为每个规格设置第一个选项作为默认值
                v.forEach((element, eindex) => {
                    this.$set(this.chooseForm, eindex, element.values[0]?.value || '')
                });
                // 调用 emitChange 来校验并修正初始选中值
                this.emitChange()
            }
        }
    },
    methods: {
        emitChange(value, values) {
            // 每次选择变化后，都检查所有规格的当前选中值
            this.specifications.forEach((sp, spi) => {
                const currentValue = this.chooseForm[spi];

                // 如果当前选中值是禁用的，或者当前规格没有选中值
                if (this.isDisabled(currentValue, spi) || !currentValue) {
                    // 则在该规格中查找第一个可用的选项
                    const firstEnabledOption = sp.values.find(spv => !this.isDisabled(spv.value, spi));
                    
                    // 将选中值更新为第一个可用的选项，如果找不到则不选中 (undefined)
                    const newValue = firstEnabledOption ? firstEnabledOption.value : undefined;
                    if (currentValue !== newValue) {
                        this.$set(this.chooseForm, spi, newValue);
                    }
                }
            });

            const currentSpv = value ? values.find(item => item.value === value) : null;
            this.$emit('change', this.selectedSku, currentSpv)
        },
        isDisabled(spvValue, spi) {
            // 规则：如果有多于一行规格，则第一行（如颜色）的选项永远不禁用
            if (this.specifications.length > 1 && spi === 0) {
                return false;
            }

            // 遍历所有 SKU，以确定当前规格选项是否应被禁用
            for (const sku of this.skuList) {
                // 检查1：当前 SKU 是否为“停用”状态
                // 注意：根据您的提示，状态路径为 sku.dmjItemDto.skuActiveStatus
                const isSkuDisabled = sku.dmjItemDto && sku.dmjItemDto.skuActiveStatus === '停用';

                if (isSkuDisabled) {
                    // 检查2：当前被禁用的 SKU 是否包含我们正在渲染的这个规格选项（如：尺码 M）
                    const containsCurrentOption = sku.skuSpecifications.some(spec =>
                        spec.name === this.specifications[spi].name && spec.value === spvValue
                    );

                    if (containsCurrentOption) {
                        // 检查3：当前被禁用的 SKU 是否也匹配其它行已选中的规格（如：颜色 浅灰色）
                        const matchesOtherSelections = this.chooseForm.every((selectedValue, selectedIndex) => {
                            // 忽略当前正在渲染的规格行，只关心其它行的选择
                            if (selectedIndex === spi) {
                                return true;
                            }
                            // 检查 SKU 中是否包含其它行选中的规格值
                            return sku.skuSpecifications.some(spec =>
                                spec.name === this.specifications[selectedIndex].name && spec.value === selectedValue
                            );
                        });

                        // 如果一个被停用的 SKU，既包含当前选项，又匹配其它所有已选规格，那么当前选项应被禁用
                        if (matchesOtherSelections) {
                            return true;
                        }
                    }
                }
            }

            // 默认不禁用
            return false;
        }
    }
}
</script>

<style lang="scss" scoped>
.DetailSpecificationButtons-item {
    display: flex;
    &_label {
        height: 32px;
        line-height: 32px;
        margin-right: 10px;
        color: #aaa;
        font-size: 14px;
        flex-shrink: 0;
    }

    &_content {
        ::v-deep .el-radio {
            margin-left: 10px;
            margin-bottom: 10px;
        }
    }

    .spvImage {
        width: 20px;
        height: 20px;
        vertical-align: top;
    }
    & + & {
        // margin-top: 20px;
    }
}
</style>